module.exports = __webpack_public_path__ + "img/store-map-default.eaad5c35.svg";